import React from "react";
import TextField from "@mui/material/TextField";

import close from "./../../../UI/general/close.svg";
import quotation from "./../../../UI/quotation/quotation.svg";
import delet from "./../../../UI/quotation/delete.svg";

/*eslint-disable*/

interface Props {
  isCollapseQuotation: any;
  handleOpenQuotation: any;
  quotationProperties: any;
  colors: any;
  handleSendQuotation: any;
  handleRemovePropertyInQuotation: any;
  isSendQuotation: any;
  statusQuotation: any;
}

interface State {
  isCollapsed: boolean;
  nameQuotation: any;
  phoneQuotation: any;
  emailQuotation: any;
  messageError: any;
}

class SidebarQuotation extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isCollapsed: true,
      nameQuotation: "",
      phoneQuotation: "",
      emailQuotation: "",
      messageError: "",
    };
  }

  handleSendQuotation = () => {
    if (
      this.state.nameQuotation !== "" &&
      this.state.phoneQuotation !== "" &&
      this.state.emailQuotation !== ""
    ) {
      this.props.handleSendQuotation({
        name: this.state.nameQuotation,
        phone: this.state.phoneQuotation,
        destino: this.state.emailQuotation,
      });
      this.setState({
        messageError: ""
      })
    }else{
      this.setState({
        messageError: "Llena todos los campos para continuar."
      })
    }
  };

  render(): React.ReactNode {
    return (
      <React.Fragment>
        {/* <div
          className={
            !this.props.isCollapseQuotation
              ? "sidebar-quotation-collapse-btn-collapsed"
              : "sidebar-quotation-collapse-btn"
          }
          onClick={() => this.props.handleOpenQuotation()}
        >
          <img src={collapsed} alt="" />
        </div> */}
        <div
          className={
            !this.props.isCollapseQuotation
              ? "sidebar-quotation-collapsed"
              : "sidebar-quotation"
          }
          /* onClick={(e) => {
            this.setState({
              openedDropdown: [],
            });
            e.preventDefault();
            e.stopPropagation();
            if (this.props.layoutsRef.current) {
              this.props.handleHideTooltip();
              this.props.layoutsRef.current.setState({
                currentSelectedProperty: "",
              });
            }
          }} */
        >
          <div
            className="quotation-close-btn"
            onClick={() => this.props.handleOpenQuotation()}
          >
            <img src={close} alt=""></img>
          </div>
          <div className="quotation-img-container">
            <img src={quotation} alt=""></img>
          </div>
          <div className="quotation-text">COTIZACIÓN</div>
          {!this.props.isSendQuotation ? (
            <div className="quotation-filters-container">
              <p className="quotation-text-subtitle">
                Llena los campos y recibirás en tu correo más información de los
                inmuebles.
              </p>
              <div className="quotation-form">
                <TextField
                  id="outlined-basic"
                  label="Nombre"
                  variant="outlined"
                  size="small"
                  onChange={(e: any) =>
                    this.setState({ nameQuotation: e.target.value })
                  }
                />
                <TextField
                  id="outlined-basic"
                  label="Celular"
                  variant="outlined"
                  size="small"
                  onChange={(e: any) =>
                    this.setState({ phoneQuotation: e.target.value })
                  }
                />
                <TextField
                  id="outlined-basic"
                  label="Correo"
                  variant="outlined"
                  size="small"
                  onChange={(e: any) =>
                    this.setState({ emailQuotation: e.target.value })
                  }
                />
              </div>
              {this.props.quotationProperties?.length > 0 ? (
                <div className="quotation-list">
                  <div className="quotation-list-title">
                    INMUEBLES SELECCIONADOS
                  </div>
                  <div className="quotation-list-description">
                    Selecciona los productos que desees cotizar desde la opción
                    inmuebles en el menú principal.
                  </div>
                  {this.props.quotationProperties?.map((item: any) => (
                    <div className="quotation-list-property">
                      <div className="quotation-list-property-info">
                        <div>{item.property}</div>
                        {
                          <div style={{ color: "#757575", fontSize: ".7rem" }}>
                            {item.values.filter(
                              (e: any) =>
                                e.hierarchicalLevel === "Jerarquico #3"
                            ).length > 0
                              ? item.values.filter(
                                  (e: any) =>
                                    e.hierarchicalLevel === "Jerarquico #3"
                                )[0].value + "/"
                              : null}
                            {item.values.filter(
                              (e: any) =>
                                e.hierarchicalLevel === "Jerarquico #2"
                            ).length > 0
                              ? item.values.filter(
                                  (e: any) =>
                                    e.hierarchicalLevel === "Jerarquico #2"
                                )[0].value + "/"
                              : null}
                            {item.values.filter(
                              (e: any) =>
                                e.hierarchicalLevel === "Jerarquico #1"
                            ).length > 0
                              ? item.values.filter(
                                  (e: any) =>
                                    e.hierarchicalLevel === "Jerarquico #1"
                                )[0].value
                              : null}
                          </div>
                        }
                      </div>
                      <div
                        className="quotation-list-property-action"
                        onClick={() =>
                          this.props.handleRemovePropertyInQuotation(item)
                        }
                      >
                        <img src={delet} />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="quotation-empty-property">
                  No hay inmuebles seleccionado
                </div>
              )}
              <div
                className="quotation-btn-send"
                style={{
                  backgroundColor: this.props.colors.main_buttons,
                  color: this.props.colors.secondary_text,
                }}
                onClick={() => this.handleSendQuotation()}
              >
                Enviar
              </div>
              {this.state.messageError.length > 0 ? <div className="quotation-txt-error" style={{
                  color: this.props.colors.main_text,
                }}>{this.state.messageError}</div> : null}
              <div className="quotation-txt-legal">
                Al presionar <strong>ENVIAR</strong> estoy aceptando los
                términos y condiciones tratados en nuestra declaración de
                privacidad.
              </div>
            </div>
          ) : (
            <div>
              <div className="quotation-res-send-title">
                Hemos recibido tu solicitud
              </div>
              <div className="quotation-res-send-description">
                En breve recibirás un correo con la información de los inmuebles
                que te han interesado.
              </div>
              <div
                className="quotation-res-send-btn-back"
                style={{
                  backgroundColor: this.props.colors.main_buttons,
                  color: this.props.colors.secondary_text,
                }}
                onClick={() => this.props.handleOpenQuotation()}
              >
                Regresar
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default SidebarQuotation;
